import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useBooleanState } from '@cian/react-utils';
import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Complaint.css';
import { ComplaintModal } from './components/ComplaintModal';
import { IconWarning } from './icons';

export interface IComplaintProps {
  offerId: number;
  isError: boolean;
  manifest: IMicrofrontendManifest | null;

  getComplaints(): void;
}

export const Complaint: React.FC<IComplaintProps> = props => {
  const { setFalse, setTrue, state } = useBooleanState();

  return (
    <div className={styles['container']}>
      <Button
        size="XS"
        beforeIcon={<IconWarning />}
        type="button"
        theme="fill_secondary"
        onClick={setTrue}
        title="Пожаловаться"
      />
      <ComplaintModal {...props} onCloseModal={setFalse} openModal={state} />
    </div>
  );
};
